import { IIntelliUploadNewDocumentRequest, IIntelliUploadNewDocumentResponse, IIntelliUploadRepository } from "@/core/repositories/intelli-upload";

export class UploadNewDocumentUseCase {
  constructor(private readonly intelliUploadRepository: IIntelliUploadRepository) {}

  async execute(request: IIntelliUploadNewDocumentRequest): Promise<IIntelliUploadNewDocumentResponse> {
    return this.intelliUploadRepository.uploadNewDocument(request);
  }
}